import React, { useState, useContext, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import Switch from "react-switch";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  modalLoading,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete } from 'react-icons/md';

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { UserContext } from "../../../../../contexts/User";
import DataTable from "../../../../common/DataTable";

const ManageSupplier = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  let {
    //customer
    getSupplier,
    supplierList,
    setSupplierList,
    setPaginatedSupplier,
    supplierForSearch,
    setSupplierForSearch,
    supplierStatusForSearch,
    setSupplierStatusForSearch,
    //pagination
    dataPaginating,
  } = useContext(UserContext);

  // States hook here
  //new customer
  let [newSupplier, setNewSupplier] = useState({
    company_name: "",
    contact_person: "",
    email: "",
    phn_no: "",
    address: "",
    desc:"",
    due: null,
    edit: false,
    editSlug: null,
    uploading: false,
  });

  //search result
  let [searchedSupplier, setSearchedSupplier] = useState({
    list: null,
    searched: false,
  });

  const searchRef = React.useRef(null);
  const [statusUpdating, setStatusUpdating] = useState({});

  //useEffect == componentDidMount
  useEffect(() => {

    setPaginatedSupplier(1);

  }, []);

  //set name, phn no hook
  const handleSetNewSupplier = (e) => {
    setNewSupplier({ ...newSupplier, [e.target.name]: e.target.value });
  };

  //Save New customer
  const handleSaveNewCustomer = (e) => {
    e.preventDefault();
    setNewSupplier({
      ...newSupplier,
      uploading: true,
    });
    const customerUrl = BASE_URL + `/settings/new-supplier`;
    let formData = new FormData();
    formData.append("name", newSupplier.company_name);
    formData.append("contact_person", newSupplier.contact_person);
    formData.append("phn_no", newSupplier.phn_no);
    formData.append("email", newSupplier.email);
    formData.append("address", newSupplier.address);
    formData.append("due", 0);
    formData.append("description", newSupplier.desc);
    return axios
      .post(customerUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewSupplier({
          company_name: "",
          contact_person: "",
          email: "",
          phn_no: "",
          address: "",
          desc:"",
          due: null,
          edit: false,
          editSlug: null,
          uploading: false,
        });
        setSupplierList(res.data[0]);
        setSupplierStatusForSearch(res.data[1]);
        setSupplierForSearch(res.data[2]);
        setLoading(false);
        toast.success(`${_t(t("Supplier has been added"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      })
      .catch((error) => {
        setLoading(false);
        setNewSupplier({
          ...newSupplier,
          uploading: false,
        });
        if (error && error.response.data.errors) {
          if (error.response.data.errors.phn_no) {
            error.response.data.errors.phn_no.forEach((item) => {
              if (item === "A supplier exists with this phone number") {
                toast.error(
                  `${_t(t("A supplier exists with this phone number"))}`,
                  {
                    position: "bottom-center",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                  }
                );
              }
            });
          }
        }
      });
  };

  //set edit true & values
  const handleSetEdit = (slug) => {
    let supplier = supplierStatusForSearch.filter((item) => {
      return item.slug === slug;
    });
    setNewSupplier({
      ...newSupplier,
      company_name: supplier[0].name,
      contact_person: supplier[0].contact_person,
      email: supplier[0].email !== "-" ? supplier[0].email : "",
      phn_no: supplier[0].phn_no,
      address: supplier[0].address,
      desc: supplier[0].description,
      due: supplier[0].due_balance,
      editSlug: supplier[0].slug,
      edit: true,
    });
  };

  //update customer
  const handleUpdateCustomer = (e) => {
    e.preventDefault();
    setNewSupplier({
      ...newSupplier,
      uploading: true,
    });
    const customerUrl = BASE_URL + `/settings/update-supplier`;
    let formData = new FormData();
    formData.append("name", newSupplier.company_name);
    formData.append("contact_person", newSupplier.contact_person);
    formData.append("phn_no", newSupplier.phn_no);
    formData.append("email", newSupplier.email);
    formData.append("address", newSupplier.address);
    formData.append("due", 0);
    formData.append("description", newSupplier.desc);
    formData.append("editSlug", newSupplier.editSlug);
    return axios
      .post(customerUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewSupplier({
          name: "",
          contact_person:"",
          email: "",
          phn_no: "",
          address: "",
          desc:"",
          due: null,
          edit: false,
          editSlug: null,
          uploading: false,
        });
        setSupplierList(res.data[0]);
        setSupplierStatusForSearch(res.data[1]);
        setSupplierForSearch(res.data[2]);
        setSearchedSupplier({
          ...searchedSupplier,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Supplier has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      })
      .catch((error) => {
        setLoading(false);
        setNewSupplier({
          ...newSupplier,
          uploading: false,
        });
        if (error && error.response.data.errors) {
          if (error.response.data.errors.phn_no) {
            error.response.data.errors.phn_no.forEach((item) => {
              if (item === "A supplier exists with this phone number") {
                toast.error(
                  `${_t(t("A supplier exists with this phone number"))}`,
                  {
                    position: "bottom-center",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                  }
                );
              }
            });
          }
        }
      });
  };

  //search customers here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedSupplier({ ...searchedSupplier, searched: false });
    } else {
      let searchedList = supplierStatusForSearch.filter((item) => {
        //name
        let lowerCaseItemName = item.name.toLowerCase();

        //email
        let lowerCaseItemEmail =
          item.email !== null && item.email.toLowerCase();

        //phn no
        let lowerCaseItemPhnNo =
          item.phn_no !== null && item.phn_no.toLowerCase();

        //address
        let lowerCaseItemAddress =
          item.address !== null && item.address.toLowerCase();

        return (
          lowerCaseItemName.includes(searchInput) ||
          (lowerCaseItemEmail && lowerCaseItemEmail.includes(searchInput)) ||
          (lowerCaseItemPhnNo && lowerCaseItemPhnNo.includes(searchInput)) ||
          (lowerCaseItemAddress && lowerCaseItemAddress.includes(searchInput))
        );
      });
      setSearchedSupplier({
        ...searchedSupplier,
        list: searchedList,
        searched: true,
      });
    }
  };

  const onClearSearch = () => {
    setSearchedSupplier({ ...searchedSupplier, searched: false });
    if (searchRef.current) searchRef.current.value = "";
  };

  const handleFetchData = (page) => {
    if (setPaginatedSupplier) setPaginatedSupplier(page);
  };

  const getListData = () => {
    if (searchedSupplier.searched) return searchedSupplier.list || [];
    return supplierList?.data || [];
  };

  const handleToggleSupplierStatus = async (item) => {
    const supplierId = item?.id;
    if (!supplierId) return;

    const nextStatus = item.status === 1 ? 0 : 1;
    setStatusUpdating((prev) => ({ ...prev, [supplierId]: true }));

    try {
      const url = BASE_URL + `/settings/update-supplier-status`;
      const formData = new FormData();
      formData.append("id", supplierId);
      formData.append("status", nextStatus);

      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });

      // If backend returns refreshed pagination/search arrays (common pattern here), use them.
      if (Array.isArray(res.data) && res.data.length >= 2) {
        setSupplierList(res.data[0]);
        setSupplierStatusForSearch(res.data[1]);
        setSupplierForSearch(res.data[2]);
        if (searchedSupplier.searched) {
          setSearchedSupplier({ ...searchedSupplier, list: res.data[1] });
        }
      }

      toast.success(`${_t(t("Supplier status updated"))}`, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    } catch (err) {

      if (err?.response?.data?.status === 0) {
        toast.error(`${_t(t(err.response.data.message))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      } else {
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    } finally {
      setStatusUpdating((prev) => ({ ...prev, [supplierId]: false }));
    }
  };

  const COLUMNS = [
    {
      header: _t(t("S/L")),
      width: "80px",
      render: (_item, index) =>
        index + 1 + ((supplierList?.current_page || 1) - 1) * (supplierList?.per_page || 0),
    },
    { header: _t(t("Name")), key: "name" },
    { header: _t(t("email")), key: "email" },
    {
      header: _t(t("Phn no")),
      render: (item) =>
        item.phn_no !== "-" && item.phn_no !== "" ? (
          <a href={`tel:${item.phn_no}`} rel="noopener noreferrer">
            {item.phn_no}
          </a>
        ) : (
          "-"
        ),
    },
    { header: _t(t("Address")), key: "address" },
    {
      header: _t(t("Status")),
      width: "120px",
      render: (item) => (
        <div className="d-flex justify-content-center">
          <Switch
            checked={item?.status === 1}
            onChange={() => handleToggleSupplierStatus(item)}
            disabled={!!statusUpdating[item?.id]}
            className="react-switch"
            name="status"
            height={22}
            width={44}
            offColor="#ee5253"
          />
        </div>
      ),
    },
    {
      header: _t(t("Action")),
      width: "140px",
      render: (item) => (
        <>
          <Link
            className="btn btn-primary ml-2 rounded-sm del-btn"
            to={`/dashboard/manage/stock/manage-edit-supplier/${item.id}`}
          >
            <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
          </Link>
          <button
            className="btn btn-danger ml-2 rounded-sm del-btn"
            onClick={() => handleDeleteConfirmation(item.slug)}
          >
            <MdDelete className="del-icon" />
          </button>
        </>
      ),
    },
  ];

  //delete confirmation modal of waiter
  const handleDeleteConfirmation = (slug) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeleteCustomer(slug);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //delete customer here
  const handleDeleteCustomer = (slug) => {
    setLoading(true);
    const customerUrl = BASE_URL + `/settings/delete-supplier/${slug}`;
    return axios
      .get(customerUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setSupplierList(res.data[0]);
        setSupplierStatusForSearch(res.data[1]);
        setSupplierForSearch(res.data[2]);
        setSearchedSupplier({
          ...searchedSupplier,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Supplier has been deleted successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch((err) => {
        setLoading(false);
        if(err.response?.data?.status === 0){
          toast.error(`${_t(t(err.response.data.message))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          return
        }
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Suppliers"))}</title>
      </Helmet>

      {/* Add modal */}
      <div className="modal fade" id="addCustomer" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newSupplier.edit
                    ? _t(t("Add new Supplier"))
                    : _t(t("Update Supplier"))}
                </h5>
              </div>
              <button
                type="button"
                id="close-btn"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              {newSupplier.uploading === false ? (
                <div key="fragment-customer-1">
                  <form
                    onSubmit={
                      !newSupplier.edit
                        ? handleSaveNewCustomer
                        : handleUpdateCustomer
                    }
                    autoComplete="off"
                  >
                    <div>
                      <label htmlFor="company_name" className="form-label">
                        {_t(t("Company Name"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="company_name"
                        name="company_name"
                        placeholder="A & Y Foods"
                        value={newSupplier.company_name || ""}
                        required
                        onChange={handleSetNewSupplier}
                      />
                    </div>

                    <div className="mt-3">
                      <label htmlFor="contact_person" className="form-label">
                        {_t(t("Contact Person"))}{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="contact_person"
                        name="contact_person"
                        placeholder="Asif"
                        value={newSupplier.contact_person || ""}
                        onChange={handleSetNewSupplier}
                      />
                    </div>

                    <div className="mt-3">
                      <label htmlFor="phn_no" className="form-label">
                        {_t(t("Phone number"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="phn_no"
                        name="phn_no"
                        placeholder="03xx xxxx xxx"
                        value={newSupplier.phn_no || ""}
                        required
                        onChange={handleSetNewSupplier}
                      />
                    </div>

                    <div className="mt-3">
                      <label htmlFor="email" className="form-label">
                        {_t(t("Email"))}{" "}
                        {/* <small className="text-danger">*</small> */}
                      </label>
                      <input                        
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="supplier@example.com"
                        value={newSupplier.email || ""}
                        onChange={handleSetNewSupplier}
                      />
                    </div>

                   

                    {/* <div className="mt-3">
                      <label htmlFor="due" className="form-label">
                        {_t(t("Previous due"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        id="due"
                        name="due"
                        required
                        className="form-control"
                        onChange={handleSetNewSupplier}
                        value={newSupplier.due}
                        placeholder="Previous due in USD"
                        required
                      />
                    </div> */}

                    <div className="mt-3">
                      <label htmlFor="address" className="form-label">
                        {_t(t("Address"))}{" "}
                        {/* <small className="text-danger">*</small> */}
                      </label>
                      <textarea
                        // required
                        type="text"
                        className="form-control"
                        id="address"
                        name="address"
                        placeholder="Type customer address"
                        value={newSupplier.address || ""}
                        onChange={handleSetNewSupplier}
                      />
                    </div>

                    
                    <div className="mt-3">
                      <label htmlFor="desc" className="form-label">
                        {_t(t("Description"))}{" "}
                        {/* <small className="text-danger">*</small> */}
                      </label>
                      <textarea
                        // required
                        type="text"
                        className="form-control"
                        id="desc"
                        name="desc"
                        placeholder="Type Description"
                        value={newSupplier.desc || ""}
                        onChange={handleSetNewSupplier}
                      />
                    </div>


                    <div className="mt-4">
                      <div className="row d-flex justify-content-end align-items-center">
                        <div className="col-3">
                          <button
                            type="submit"
                            className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          >
                            {!newSupplier.edit
                              ? _t(t("Save"))
                              : _t(t("Update"))}
                          </button>
                        </div>
                        <div className="col-3">
                          <button
                            type="button"
                            className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                            data-dismiss="modal"
                          >
                            {_t(t("Close"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row d-flex justify-content-end align-items-center">
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          {!newSupplier.edit ? _t(t("Save")) : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-table-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {/* {newSupplier.uploading === true || loading === true ? (
                      tableLoading()
                    ) : ( */}
                      <div key="fragment3">
                        {/* next page data spin loading */}
                        {/* spin loading ends */}

                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t("Supplier List"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center">
                              {/* Search customer */}
                              <div className="col-md-9 t-mb-15 mb-md-0">
                                <div className="input-group">
                                  <div className="form-file">
                                    <input
                                      ref={searchRef}
                                      type="text"
                                      className="form-control border-0 form-control--light-1 rounded-left"
                                      placeholder={_t(t("Search")) + ".."}
                                      onChange={handleSearch}
                                    />
                                  </div>
                                  <button
                                    className="btn btn-primary rounded-right"
                                    type="button"
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              {/* Add customer modal trigger button */}
                              <div className="col-md-3 text-md-right">
                                <Link
                                  className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                                  to="/dashboard/manage/stock/manage-new-supplier"
                                >
                                  {_t(t("add new"))}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Table */}
                        <DataTable
                          loading={loading || dataPaginating}
                          data={getListData()}
                          columns={COLUMNS}
                          emptyText="No data available"
                          pagination={{
                            isPageLoading: loading,
                            isPagination: true,
                            pageCount: supplierList?.last_page,
                            currentPage: supplierList?.current_page,
                            from: supplierList?.from,
                            to: supplierList?.to,
                            total: supplierList?.total,
                          }}
                          handleFetchData={handleFetchData}
                          searchPayload={{
                            isSearched: searchedSupplier.searched,
                            onClearSearch,
                          }}
                        />
                      </div>                   
                  </div>
                </div>
              </div>

              {/* pagination is handled by DataTable */}
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default ManageSupplier;
